/*
  Sécurys — cadeaux automatiques du panier.
  Règles (config dans #sg-config, rendue par snippets/cart-drawer.liquid) :
  - un lot Sécurys >= colisMin  => exactement 1 « Colis 100 % discret »
  - un lot Sécurys >= filetMin  => en plus exactement 1 « Filet de lavage — Cadeau »
  - sinon les cadeaux sont retirés ; quantité forcée à 1 ; propriété _gift=true.
  Écritures : retraits/quantités en un POST JSON /cart/update.js, ajouts en UN POST JSON
  /cart/add.js (items[] groupés).
  Le web pixels manager de Shopify enveloppe window.fetch / XHR et émet product_added_to_cart
  (=> AddToCart Meta) pour tout /cart/add, /cart/change et /cart/update, y compris items[].
  Les écritures cadeaux et « lot supérieur » passent donc par le fetch d'une iframe vierge de
  même origine (mêmes cookies, même panier) : aucun AddToCart en plus de l'ajout client.
  Pas de boucle : on lit le panier, on calcule l'écart, on n'écrit que s'il y en a un.
*/
(function () {
  if (window.__sgGifts) return;
  window.__sgGifts = true;

  function cfg() {
    var el = document.getElementById('sg-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function r(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  var quietFetch = null;
  function qfetch(url, opts) {
    if (!quietFetch) {
      try {
        var f = document.createElement('iframe');
        f.setAttribute('aria-hidden', 'true');
        f.tabIndex = -1;
        f.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden';
        document.documentElement.appendChild(f);
        var w = f.contentWindow;
        if (w && typeof w.fetch === 'function') quietFetch = w.fetch.bind(w);
      } catch (e) {}
      if (!quietFetch) quietFetch = window.fetch.bind(window);
    }
    return quietFetch(new URL(url, location.href).href, opts);
  }

  function getCart() {
    return fetch(r('cart_url', '/cart') + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); });
  }
  function post(url, data) {
    return qfetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    }).then(function (res) {
      if (!res.ok) return res.text().then(function (t) { throw new Error(t); });
      return res.json();
    });
  }

  function isGiftProp(item) {
    return !!(item.properties && String(item.properties._gift) === 'true');
  }
  function lotOf(item, c) {
    if (item.handle !== c.handle || isGiftProp(item)) return 0;
    var opt = (item.options_with_values || []).filter(function (o) { return o.name === c.lotOption; })[0];
    if (!opt) return 0;
    var m = String(opt.value).match(/(\d+)\s*$/);
    return m ? parseInt(m[1], 10) : 0;
  }

  function plan(cart, c) {
    var maxLot = 0;
    cart.items.forEach(function (i) { maxLot = Math.max(maxLot, lotOf(i, c)); });
    var want = {};
    want[c.colis] = maxLot >= c.colisMin;
    want[c.filet] = maxLot >= c.filetMin;
    var updates = {}, adds = [];
    [c.colis, c.filet].forEach(function (vid) {
      var kept = false;
      cart.items.forEach(function (l) {
        if (l.variant_id !== vid) return;
        if (want[vid] && isGiftProp(l) && !kept) {
          kept = true;
          if (l.quantity !== 1) updates[l.key] = 1;
        } else {
          updates[l.key] = 0;
        }
      });
      if (want[vid] && !kept) adds.push({ id: vid, quantity: 1, properties: { _gift: 'true' } });
    });
    return { updates: updates, adds: adds };
  }

  var busy = false, again = false;
  function reconcile() {
    var c = cfg();
    if (!c || !c.colis || !c.filet) return Promise.resolve(false);
    if (busy) { again = true; return Promise.resolve(false); }
    busy = true;
    var changed = false;
    function pass(n) {
      if (n > 2) return Promise.resolve();
      return getCart().then(function (cart) {
        var p = plan(cart, c);
        var hasUpd = Object.keys(p.updates).length > 0;
        if (!hasUpd && !p.adds.length) return;
        var chain = Promise.resolve();
        if (hasUpd) chain = chain.then(function () { return post(r('cart_update_url', '/cart/update') + '.js', { updates: p.updates }); });
        if (p.adds.length) chain = chain.then(function () {
          return post(r('cart_add_url', '/cart/add') + '.js', { items: p.adds });
        });
        return chain.then(function () { changed = true; return pass(n + 1); });
      });
    }
    return pass(1)
      .catch(function (e) { console.error('[securys-gifts]', e); })
      .then(function () {
        busy = false;
        if (again) { again = false; return reconcile().then(function (ch) { return changed || ch; }); }
        return changed;
      });
  }

  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function refreshDrawer() {
    var drawer = document.querySelector('cart-drawer');
    var bubble = document.getElementById('cart-icon-bubble');
    return Promise.all([
      fetch(r('cart_url', '/cart') + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' }).then(function (res) { return res.json(); }),
      getCart()
    ]).then(function (out) {
      var s = out[0], cart = out[1];
      if (drawer && s['cart-drawer']) {
        var src = parse(s['cart-drawer']).querySelector('.drawer__inner');
        var dst = drawer.querySelector('.drawer__inner');
        if (src && dst) dst.innerHTML = src.innerHTML;
        drawer.classList.toggle('is-empty', cart.item_count === 0);
      }
      if (bubble && s['cart-icon-bubble']) {
        var sec = parse(s['cart-icon-bubble']).querySelector('.shopify-section');
        if (sec) bubble.innerHTML = sec.innerHTML;
      }
    });
  }

  function afterChange() {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return Promise.resolve(); }
    return refreshDrawer();
  }

  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      reconcile().then(function (changed) { if (changed) return afterChange(); });
    }, 60);
  }

  // « Passer au lot supérieur » : même taille, même quantité, en une seule requête,
  // puis les cadeaux suivent.
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sg-upgrade]');
    if (!b) return;
    e.preventDefault();
    if (b.getAttribute('aria-busy') === 'true') return;
    b.setAttribute('aria-busy', 'true');
    b.classList.add('is-loading');
    var to = parseInt(b.dataset.to, 10), qty = parseInt(b.dataset.qty, 10) || 1;
    getCart().then(function (cart) {
      var existing = 0;
      cart.items.forEach(function (i) { if (i.variant_id === to && !isGiftProp(i)) existing += i.quantity; });
      var updates = {};
      updates[b.dataset.key] = 0;
      updates[to] = existing + qty;
      return post(r('cart_update_url', '/cart/update') + '.js', { updates: updates });
    }).then(reconcile).then(refreshDrawer).catch(function (err) {
      console.error('[securys-gifts]', err);
      b.removeAttribute('aria-busy');
      b.classList.remove('is-loading');
    });
  });

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    }
    var c = cfg();
    if (c && c.count > 0) schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
